import { Button, DatePicker, Form, Input, Modal, Radio, Select } from 'antd';
import { NotificationTemplateFilterFormFieldList, NotificationTemplateFilterFormValues, NotificationTemplateFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useGetTemplate } from 'features/notification/use-cases/get-template';
import { useSendFirebaseNotification } from 'features/notification/use-cases/send-firebase-notifications-template';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { usePaginationParams } from 'hooks/use-pagination-params';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';

const getInitialFilterValues: NotificationTemplateFilterFormValues = {
    Id: undefined,
    Title: undefined,
    TitleAr: undefined,
    ContentEn: undefined,
    ContentAr: undefined,
    Image: undefined,
    ImageUrl: undefined,
    AnnouncementType: undefined,
    templateId: null,
    TemplateName: undefined,
    ImageAr: undefined,
    RedirectionUrl: undefined,
    ImageUrlAr: undefined
};

export const SendFirebaseNotificationModal = ({ onClose, refetch, sessionId, allUser }: { onClose: () => void; showAddItemModal: boolean, refetch: () => void, sessionId: string, allUser: any }) => {

    const formName = 'send-firebase-notification-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<NotificationTemplateFilterFormValues>();
    const { isLoading, mutate } = useSendFirebaseNotification();
    const [contentEn, setContentEn] = useState<string>("");
    const [contentAr, setContentAr] = useState<string>("");
    const [templateImage, setTemplateImage] = useState<File | any>(null);
    const deliverType = Form.useWatch("deliveryType", form);
    const handleProcedureContentChange = (
        content: React.SetStateAction<string>,
    ) => {

        setContentEn(content);
    };
    const [successModal, setSuccessModal] = useState(false);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [templateImageAr, setTemplateImageAr] = useState<File | null>(null);
    const [imagePreviewAr, setImagePreviewAr] = useState<string | null>(null);

    const title = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLE,
        form
    );
    const titlear = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLEAR,
        form
    );
    const { params, updateParams } =
        usePaginationParams<NotificationTemplateFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
        });

    const [templateId, setTemplateId] = useState(0);
    const { data: templateData } = useGetTemplate(params, {
        retry: false,
        enabled: templateId > 0,
    });




    const handleProcedureContentArChange = (
        content: React.SetStateAction<string>,
        // delta: any,
        // source: any,
        // editor: any
    ) => {

        setContentAr(content);
    };
    const { data: notificationModalType } = useGetDropDownData({
        flag: "announcementtype",
        searchId: 0,
        SearchKey: ""
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: false
    });


    const { data: templateList } = useGetDropDownData({
        flag: "notificationtemplate",
        searchId: 0,
        SearchKey: ""
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: false
    });

    const handleClose = () => {
        onClose();

        form.resetFields();
        setImagePreview(null);       // resets preview
        setTemplateImage(null);
        setTemplateImageAr(null);    // reset AR image
        setImagePreviewAr(null)
        setContentEn("");            // reset English editor
        setContentAr("");            // reset Arabic editor


    }
    useEffect(() => {
        form.resetFields();

        updateParams({ templateId: null });

        setContentEn("");
        setContentAr("");
        setImagePreview(null);
        setImagePreviewAr(null);

    }, [onClose]); //


    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setTemplateImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };
    // AR image upload
    const handleFileChangeAr = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setTemplateImageAr(file);
            setImagePreviewAr(URL.createObjectURL(file));
        }
    };

    const { t } = useTranslation();
    useEffect(() => {
        if (templateData?.items) {
            const tempData = templateData?.items[0] || null;
            form.setFieldsValue({
                Title: tempData?.Title,
                TitleAr: tempData?.TitleAr,
                AnnouncementType: tempData?.AnnouncementTypeId,
                ContentEn: tempData?.ContentEn,
                ContentAr: tempData?.ContentAr,
                ImageUrl: tempData?.ImageUrl,
                ImageUrlAr: tempData?.ArabicImage_Url
            });

            setContentEn(tempData?.ContentEn || "");
            setContentAr(tempData?.ContentAr || "");
            setImagePreview(tempData?.ImageUrl || null);
            setImagePreviewAr(tempData?.ArabicImage_Url
 || null);
        }

    }, [templateData]);
    const getInitialValues = {
        [NotificationTemplateFilterFormFieldList.ID]: undefined,
        [NotificationTemplateFilterFormFieldList.TITLE]: undefined,
        [NotificationTemplateFilterFormFieldList.TITLEAR]: undefined,
        [NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID]: undefined,
        [NotificationTemplateFilterFormFieldList.CONTENTEN]: undefined,
        [NotificationTemplateFilterFormFieldList.CONTENTAR]: undefined,
        [NotificationTemplateFilterFormFieldList.IMAGE]: undefined,
        [NotificationTemplateFilterFormFieldList.IMAGEURL]: undefined,
        [NotificationTemplateFilterFormFieldList.ImageUrlAr]: undefined

    };
    const hanldeSuccess = () => {
        handleClose();
        setSuccessModal(true);

        refetch();
        sessionStorage.removeItem("sessionId");
    }

    const handleUpdate = (formData: any) => {
        formData[NotificationTemplateFilterFormFieldList.SESSIONID] = sessionId;
        formData[NotificationTemplateFilterFormFieldList.ISINSTANT] = (formData[NotificationTemplateFilterFormFieldList.DELIVERYTYPE] == undefined) ? true : false;
        formData[NotificationTemplateFilterFormFieldList.TEMPLATEID] = templateId;
        // if (deliverType == 2) {
        //     formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE] = formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE]?.format("YYYY-MM-DD HH:mm");
        //     // formData[NotificationTemplateFilterFormFieldList.SCHEDULETIME] = formData[NotificationTemplateFilterFormFieldList.SCHEDULETIME]?.format("HH:mm:ss");
        // }

        if (deliverType == 2 && formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE]) {
            formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE] = formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE].toDate().toUTCString();
        }

        // formData[NotificationTemplateFilterFormFieldList.IMAGE] = templateImage;
        if (templateImage) {
            formData[NotificationTemplateFilterFormFieldList.IMAGE] = templateImage;
        }

        if (templateImageAr) {
            formData[NotificationTemplateFilterFormFieldList.IMAGEAR] = templateImageAr;
        }
        formData.flag = allUser
        mutate(formData, { onSuccess: hanldeSuccess });
    };

    return (
        <>
            <div className='popup template_modal'>
                <div className='modal_head'>
                    <h4> Send a New Firebase Notification</h4>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                </div>
                <div className='modal_body' >
                    <Form<NotificationTemplateFilterFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);

                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                        requiredMark={true}
                        scrollToFirstError
                    >



                        <div className='templte_review'>
                            <div style={{ width: '50%' }}>
                                <FormSectionsSeparator title={"Notification Content"} >
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label="Select Template"
                                        name={NotificationTemplateFilterFormFieldList.TEMPLATENAME}
                                    >
                                        <Select placeholder="Select Type"
                                            style={{ width: "100%" }}
                                            options={templateList?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                            onChange={(value: number) => {
                                                setTemplateId(value);
                                                updateParams({
                                                    templateId: value,
                                                });
                                            }}
                                            allowClear

                                        >
                                        </Select>
                                    </Form.Item>
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label="Notification Type"
                                        name={NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID}
                                    >
                                        <Select placeholder="Select Type"
                                            style={{ width: "100%" }}
                                            options={notificationModalType?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                            disabled
                                            allowClear>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label={"English Notification Title"}
                                        name={NotificationTemplateFilterFormFieldList.TITLE}
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: t('validateMessages.custom.nomsg'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={"Enter Notification Title"}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Arabic Notification Title"
                                        name={NotificationTemplateFilterFormFieldList.TITLEAR}
                                        style={{ direction: "rtl", textAlign: "right" }}
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Input
                                            placeholder="Enter Notification TitleAr"
                                            style={{ direction: "rtl", textAlign: "right" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="English Message"
                                        name={NotificationTemplateFilterFormFieldList.CONTENTEN}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "Message is required" }
                                        ]}
                                    >
                                        <ReactQuill
                                            className="editor-small cstm_editor "
                                            theme="snow"
                                            value={contentEn || ""}
                                            onChange={handleProcedureContentChange}

                                            modules={SendFirebaseNotificationModal.modules}
                                            formats={SendFirebaseNotificationModal.formats}
                                            placeholder="Enter your message here..."
                                        // dangerouslySetInnerHTML={{ __html: code }}
                                        // readOnly={!edit}
                                        />
                                    </Form.Item>
                                    {/* <Space></Space> */}
                                    <Form.Item
                                        className="arabic-editor"
                                        label="Arabic Message"
                                        style={{ direction: "rtl", textAlign: "right" }}

                                        name={NotificationTemplateFilterFormFieldList.CONTENTAR}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "MessageAr is required" }
                                        ]}
                                    >
                                        <ReactQuill
                                            className="editor-small cstm_editor "
                                            theme="snow"
                                            value={contentAr || ""}
                                            onChange={handleProcedureContentArChange}
                                            modules={SendFirebaseNotificationModal.modules}
                                            formats={SendFirebaseNotificationModal.formats}
                                            placeholder="Enter your message here..."
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={" English Image"}
                                        name={'image'}
                                    >
                                        <Input type="file" onChange={handleFileChange} accept=".png,.jpg,.jpeg" />
                                    </Form.Item>
                                    <Form.Item
                                        name={NotificationTemplateFilterFormFieldList.IMAGEURL}
                                        hidden
                                    >

                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Arabic Image" name={'ImageAr'} style={{ direction: "rtl", textAlign: "right" }}>
                                        <Input
                                            type="file"
                                            onChange={handleFileChangeAr}
                                            accept=".png,.jpg,.jpeg"
                                        // ref={imageArInputRef as any}
                                        />
                                        <Form.Item
                                        name={NotificationTemplateFilterFormFieldList.ImageUrlAr}
                                        hidden
                                    >

                                        <Input />
                                    </Form.Item>
                                    </Form.Item>
                                    <Form.Item
                                        label="Redirection Link"
                                        name={NotificationTemplateFilterFormFieldList.RedirectionUrl}
                                    >
                                        <Input placeholder="https://example.com" style={{ color: 'blue' }} />
                                    </Form.Item>
                                </FormSectionsSeparator>

                                <FormSectionsSeparator title={"Delivery Setting"}>
                                    <Form.Item label="Delivery Type" name={NotificationTemplateFilterFormFieldList.DELIVERYTYPE}
                                    >
                                        <Radio.Group >
                                            <Radio defaultChecked>{1}Instant Notification</Radio>
                                            <Radio value={2}>Scheduled Notification</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {deliverType == 2 && (
                                        <Form.Item
                                            label="Schedule Date"
                                            name={NotificationTemplateFilterFormFieldList.SCHEDULEDATE}
                                            rules={[{ required: true, message: "Please select date" }]}
                                        >
                                            <DatePicker
                                                showTime
                                                style={{ width: "100%" }}
                                                format="DD/MM/YYYY HH:mm" // 
                                                placeholder="DD/MM/YYYY HH:mm"
                                            // format="DD/MM/YYYY"
                                            // placeholder="DD/MM/YYYY"
                                            />
                                        </Form.Item>
                                    )}
                                </FormSectionsSeparator>
                            </div>
                            <Modal
                                open={successModal}
                                footer={null}
                                closable={true}
                                onCancel={() => {
                                    setSuccessModal(false);
                                    handleClose();
                                }}
                                centered
                                width={400}
                            >
                                <div className="success-modal-container">

                                    <div className="success-circle">
                                        <span className="success-icon">✔</span>
                                    </div>

                                    <h2 className="success-title">
                                        Saved!
                                    </h2>

                                    <p className="success-text">
                                        Notification has been sent successfully.
                                        
                                    </p>
                                </div>
                            </Modal>
                            <Form.Item className='preview_dtl'>
                                <div
                                >
                                    <div
                                        style={{
                                            background: '#f0f0f0',
                                            borderRadius: 4,
                                            padding: 16,

                                        }} >
                                        <h4>Your Notification Look Like</h4>
                                        <p>View how your template will appear before final use</p>
                                        <div className='notify_preview'>
                                            <div className='en'>
                                                <h3 >English Preview</h3>
                                                <div className="eng_prviw">
                                                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                                                        {title || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentEn || 'No description here'
                                                        }}
                                                    />
                                                    {imagePreview && (
                                                        <div className='img_box'>
                                                            <img
                                                                src={imagePreview}
                                                                alt="Preview EN"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}

                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='ar'>
                                                <h3 >Arabic Preview</h3>
                                                <div className='eng_prviw'>
                                                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                                                        {titlear || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentAr || 'No description here'
                                                        }}
                                                    />
                                                    <div className='img_box'>
                                                        {imagePreviewAr && (
                                                            <img
                                                                src={imagePreviewAr}
                                                                alt="Preview AR"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}
                                                            />

                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>
                        <div className='form-button'>
                            <Button htmlType='submit' className='btn' type='primary'>Send Notification</Button>
                        </div>
                    </Form>
                </div>
            </div >
        </>
    )
};
SendFirebaseNotificationModal.modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }], // Select dropdown for heading
        [{ 'font': [] }], // Select dropdown for font size
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'align': [] }], // Select dropdown for text alignment
        [{ 'color': [] }, { 'background': [] }], // Select dropdowns for text and background color
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link'],
        ['clean']
    ],
    clipboard: {
        matchVisual: true,
    }
};
SendFirebaseNotificationModal.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'color', 'background'
];